CoverageApp.Models.Coverage = Backbone.Model.extend({
    // url: "/api/resources/csv-upload-company-check",
    
    defaults: {
        files: 0,
        link: '',
        status: 'idle',
        jobId: null,
        currentOffset: 0,
        results: []
    },

    initialize: function() {
        const savedJobId = localStorage.getItem('active_job_id');
        if (savedJobId) {
            this.set('jobId', savedJobId);
            this.set('status', 'processing');
        }
        // Load files on initialization
        this.initDownloads();
    },

    startProcess: function(fileInput, searchType) {
        if (!fileInput.files[0]) return;

        const formData = new FormData();
        formData.append('csv_file', fileInput.files[0]);
        formData.append('searchType', searchType);

        this.set({ status: 'uploading', results: [], currentOffset: 0 });

        $.ajax({
            url: "/api/resources/csv-upload",
            type: 'POST',
            data: formData,
            processData: false,
            contentType: false,
            success: (res) => {
                this.set('jobId', res.job_id);
                this.set('status', 'uploaded_processing'); 
                localStorage.setItem('active_job_id', res.job_id); 
            },
            error: () => this.set('status', 'error')
        });
    },


    initDownloads: function() {
        $.ajax({
            url: "/api/resources/coverage-files",
            type: 'GET',
            success: (res) => {
                this.set({
                    'files': res, 
                    'status': 'loaded'
                });
            },
            error: () => this.set('status', 'error')
        });
    },

    getDownloadLink: function(id) {
        return $.ajax({
            url: "/api/resources/get-download-url",
            type: 'POST',
            data: { id }
        })
        .done((res) => {
            this.set({
                'link': res, 
                'status': 'loaded'
            });
        })
        .fail(() => {
            this.set('status', 'error');
        });
    }
});
